<!-- Expanded panel -->
<aside
   class="hpp-panel"
   *ngIf="!minimized">
   <div class="hpp-panel__header">
      <span class="hpp-panel__title">
         <i class="fas fa-chart-pie"></i>
         Hospital Progress
      </span>
      <button
         type="button"
         class="hpp-panel__toggle"
         (click)="toggleMinimized()"
         title="Minimize panel"
         aria-label="Minimize hospital progress panel">
         <i class="fa fa-minus"></i>
      </button>
   </div>

   <div class="hpp-top-card-row">
      <div class="hpp-top-card">
         <span>Rosters Complete</span>
         <span class="hpp-pct">{{ overallReviewTypePct }}%</span>
      </div>

      <div class="hpp-top-card hpp-top-card-2">
         <span>Completed Reviews</span>
         <span class="hpp-pct">{{ overallPct }}%</span>
      </div>
   </div>

   <div class="hpp-card">
      <div class="hpp-card__body">
         <div class="hpp-card__bars">
            <div class="hpp-bar">
               <div
                  class="hpp-rt__row"
                  *ngFor="let stat of practiceStats; trackBy: trackByPractice">
                  <span
                     class="hpp-rt__name"
                     style="flex: 0 0 50%">
                     {{ stat.practiceName }}
                     <span
                        class="hpp-card__deferred-badge"
                        *ngIf="stat.deferredCount > 0"
                        [title]="stat.deferredCount + ' deferred team member' + (stat.deferredCount === 1 ? '' : 's')">
                        ({{ stat.deferredCount }} deferred)
                     </span>
                  </span>
                  <span
                     class="hpp-rt__pct hpp-badge-1"
                     style="flex: 0 0 20%">
                     {{ stat.reviewTypeSelected }}/{{ stat.total }} assigned
                  </span>
                  <span
                     class="hpp-rt__pct hpp-badge-2"
                     style="flex: 0 0 30%">
                     {{ stat.inProgress }}/{{ stat.total }} reviews in progress
                  </span>
               </div>
            </div>
         </div>
      </div>
   </div>

   <div
      class="hpp-panel__empty"
      *ngIf="practiceStats.length === 0">
      No practices to display
   </div>
</aside>

<!-- Minimized rail -->
<aside
   class="hpp-rail"
   *ngIf="minimized"
   (click)="toggleMinimized()"
   title="Expand hospital progress panel"
   role="button"
   tabindex="0"
   style="gap: 0px"
   (keydown.enter)="toggleMinimized()">
   <div class="hpp-panel__header">
      <span class="hpp-panel__title">
         <i class="fas fa-chart-pie"></i>
         Hospital Progress
      </span>
      <button
         type="button"
         class="hpp-panel__toggle"
         (click)="$event.stopPropagation(); toggleMinimized()"
         title="Maximize panel"
         aria-label="Maximize hospital progress panel">
         <i class="fa fa-plus"></i>
      </button>
   </div>

   <div class="hpp-top-card-row">
      <div
         class="hpp-top-card"
         style="padding: 6px 10px">
         <span class="hpp-pct">{{ overallReviewTypePct }}%</span>
      </div>

      <div
         class="hpp-top-card hpp-top-card-2"
         style="padding: 6px 10px">
         <span class="hpp-pct">{{ overallPct }}%</span>
      </div>
   </div>
   <div style="display: flex">
      <span style="margin-right: 5px; text-align: right; font-size: 10px; color: #363636; font-weight: 400; letter-spacing: 0.2px; line-height: 12px">
         Rosters
         <br />
         Complete
      </span>
      <span style="margin-left: 5px; font-size: 10px; color: #363636; font-weight: 400; letter-spacing: 0.2px; line-height: 12px">
         Completed
         <br />
         Reviews
      </span>
   </div>
</aside>
